const baseStyle = () => ({
  button: {
    _focusVisible: {
      boxShadow: 'insetOutline'
    }
  }
})

export const Accordion = {
  baseStyle
}
